"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));
var _excluded = ["className"];
var Spinner = function Spinner(_ref) {
  var className = _ref.className,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: "".concat(_stylesModule["default"].Spinner).concat(className ? " ".concat(className) : '')
  }, props), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faCircleNotch"
  }));
};
var _default = Spinner;
exports["default"] = _default;